import { Injectable } from '@angular/core';

//Zur Wiederverwendung im Rahmen der USignal-Administration
@Injectable({ providedIn: 'root' })
export class USignalFacade {
	constructor() {}
}
